import React, {useState, useEffect, useRef, useCallback} from "react";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {useDispatch, useSelector} from "react-redux";
import {
  fetchDocumentAsBase64,
  fetchDocumentAsBase64FromServer,
} from "../../constants/docusignService";
import {API_URL} from "../../constants/constants";
import {Breadcrumbs, Button, Typography} from "@mui/material";
import {Box, Grid} from "@mui/system";
import style from "../../assets/css/client-select.module.scss";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import {IoIosArrowRoundBack} from "react-icons/io";
import {isMobile} from "react-device-detect";
import {DOCUSIGN_PREPARE} from "../../constants/apiConstant";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
const DocusignInitiate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {showLoader, eSignModal} = useSelector(selectUiState);
  const {docusignData, docusignURL} = useSelector(selectDataStoreState);

  const [error, setError] = useState(null);
  const [authUrl, setAuthUrl] = useState("");
  const [envelopeId, setEnvelopeId] = useState(null);
  const [signingUrl, setSigningUrl] = useState(null);
  const [documentDataCallback, setDocumentDataCallback] = useState(null);

  const navigate = useNavigate();

  // Generate a random state value for OAuth security

  // Initialize the OAuth flow
  const initiateSigning = useCallback(async () => {
    dispatch(setUiData({showLoader: true}));
    dispatch(setDataStore({docusignURL: null}));
    setLoading(true);
    setError(null);

    const data = {
      proposal_id: docusignData?.proposal_id,
      signer_email: docusignData?.email,
      signer_name: docusignData?.full_name,
      document_path: docusignData?.proposal_pdf,
    };

    const options = {
      method: DOCUSIGN_PREPARE.method,
      headers: DOCUSIGN_PREPARE.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(DOCUSIGN_PREPARE.url, options);
      const res = await response.json();

      if (res.success && res.signing_url) {
        dispatch(setDataStore({docusignURL: res.signing_url}));

        const width = 850;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const authWindow = window.open(
          res.signing_url,
          "_blank",
          `width=${width},height=${height},top=${top},left=${left}`
        );

        if (
          !authWindow ||
          authWindow.closed ||
          typeof authWindow.closed === "undefined"
        ) {
          GlobalNotificationPopup({
            type: "error",
            message:
              'Popup blocked! Please allow popups for this site, then click "Sign Your Proposal" again.',
          });
        }

        const interval = setInterval(() => {
          if (authWindow.closed) {
            clearInterval(interval);
            dispatch(setDataStore({docusignData: null, docusignURL: null}));
            // console.log("DocuSign window closed");
          }
        }, 500);
      } else {
        setError("Failed to prepare the signing process. Please try again.");
      }
    } catch (err) {
      setError("Failed to complete signing process");
      console.error(err);
    } finally {
      setLoading(false);
      dispatch(setUiData({showLoader: false}));
    }
  }, [docusignData, dispatch, setLoading, setError]);

  const hasInitiatedSigning = useRef(false);

  useEffect(() => {
    if (!docusignData && !docusignURL) {
      //initiateSigning();
      // hasInitiatedSigning.current = true; // Mark as called
      // handleSignDocument(docusignData)

      navigate("/submitted-proposal");
    }
  }, [docusignData, docusignURL]);

  return (
    <>
      <section className={style.selectClientSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}} sx={{mt: {lg: 3, xl: 3, sm: 2, xs: 2}}}>
            <div className={style.propPagination}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  color="inherit"
                  to="/dashboard"
                  style={{color: "inherit", textDecoration: "none"}}
                >
                  Dashboard
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  to="/submitted-proposal"
                  style={{color: "inherit", textDecoration: "none"}}
                >
                  Submitted Proposals
                </Link>
                <Typography sx={{color: "text.primary"}}>Signature</Typography>
              </Breadcrumbs>
            </div>
          </Grid>
        </Grid>
        <div className={style.selectClientMain}>
          <div>
            <h2>Add Your Signature to Finalize</h2>
            <p style={{color: "#3e3e3e"}}>
              {" "}
              Your digital signature is required to complete{" "}
              {!isMobile ? <br /> : null} this proposal & declarations.
            </p>
            {/* {docusignURL ? (
                            null

                        ) : ( */}
            <Box sx={{textAlign: "center", mt: 2}}>
              <Button
                style={{
                  background: "#004f71",
                  color: "#fff",
                  textTransform: "capitalize",
                }}
                variant="contained"
                onClick={initiateSigning}
                disabled={showLoader}
              >
                Sign Your Proposal
              </Button>
            </Box>
            {/* )} */}
          </div>
        </div>
        {/* <div>
                        <p>Client Name: </p><span>{eSignModal?.full_name}</span>
                        <p>Client Email: </p><span>{eSignModal?.email}</span>
                        <p>Proposal Number: </p><span>{eSignModal?.proposal_id}</span>
                        <p>Hard Quote Amt: </p><span>{eSignModal?.formated_hard_quote}</span>
                        <p>Soft Quote Amt: </p><span>{eSignModal?.formated_soft_quote}</span>
                        <p>Date: </p><span>{eSignModal?.proposal_date}</span>
                    </div> */}
      </section>
    </>
  );
};

export default DocusignInitiate;
